
<section
  class="container-vs-pods-main-container bg-themeComponentBg-light font-rubik"
  aria-labelledby="cvp-heading"
>
  <div class="w-full flex justify-center item-center">
    <div class="w-full max-w-1024 flex flex-col justify-start items-start">
      <h2 id="cvp-heading" class="main-h">Containers vs Pods®</h2>
      <p class="main-txt">
        Container Alliance provides heavy duty shipping containers for sale or rent that are also great
        for portable storage applications. There are some substantial differences between Pods®
        that are intended for moving and storage.
      </p>
    </div>
  </div>

  <div class="w-full hidden lg:flex justify-center item-center">
    <table
      class="max-w-1024 w-full border-separate border-spacing-0 table-auto [&_td]:!border-[#EDE9E3]"
    >
      <caption class="sr-only">
        Feature comparison between Pods® and shipping containers
      </caption>

      <thead>
        <tr>
          <th />
          <th
            class="column-title text-[1rem] leading-[2rem] bg-[#EDE9E3] border-[#D4CBBF] border !font-medium rounded-t-lg"
            scope="col"
          >
            <p class="px-5 py-4">Pods®</p>
          </th>
          <th />
          <th
            class="column-title border-[#D4CBBF] border rounded-t-lg bg-white-important"
            scope="col"
          >
            <p class="px-5 py-4">Containers</p>
            <div class="w-full flex justify-center mt-[25px]">
              <button
                type="button"
                aria-label="Get a quote"
                class="get-quote-button flex items-center justify-center"
                data-vue-init="lead-flow"
                data-props='{ "gtag": "get_quote"}'
              >
                <p>Get started</p>
              </button>
            </div>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(item, index) in containerVsPods"
          :key="item.name"
          class="[&_td]:!p-2 [&_td]:text-[1rem] [&_td]:leading-[1.5rem]"
        >
          <th
            class="row-title"
            :class="{ 'no-border': index === 0 }"
            scope="row"
          >
            {{ item.name }}
          </th>

          <td
            class="w-full flex justify-center items-center bg-[#EDE9E3]"
            style="border: 1px solid #D4CBBF !important"
          >
            <img
              v-if="item.pods"
              src="@/images/containers-vs-pods/true.png"
              alt="Yes"
            />
            <img
              v-else
              src="@/images/containers-vs-pods/false.png"
              alt="No"
            />
          </td>

          <td class="!p-0 border border-[#D4CBBF]" />

          <td
            class="w-full flex justify-center items-center border border-[#D4CBBF] bg-white"
          >
            <img
              v-if="item.containers"
              src="@/images/containers-vs-pods/true.png"
              alt="Yes"
            />
            <img
              v-else
              src="@/images/containers-vs-pods/false.png"
              alt="No"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="w-full lg:hidden flex justify-center item-center mobile-table-container">
    <div class="w-full">
      <div class="w-full flex flex-row h-[180px]">
        <div class="bg-[#EDE9E3] p-5 border-tl-rounded border border-[#D4CBBF]">
          <p class="mobile-table-h">Pods®</p>
        </div>
        <div class="bg-white p-5 border-tr-rounded border border-[#D4CBBF]">
          <p class="mobile-table-h">Containers</p>
          <div class="w-full flex justify-center mt-[30px]">
            <button
              type="button"
              aria-label="Get a quote"
              class="get-quote-button flex items-center justify-center"
              data-vue-init="lead-flow"
              data-props='{ "gtag": "get_quote"}'
            >
              <p>Get started</p>
            </button>
          </div>
        </div>
      </div>

      <div
        v-for="(item, index) in containerVsPods"
        :key="item.name"
        class="w-full flex flex-col"
      >
        <div class="w-full flex flex-col justify-center pl-4 mobile-item-name">
          <p>{{ item.name }}</p>
        </div>

        <div class="w-full flex h-56px">
          <div
            class="w-full flex justify-center items-center bg-[#EDE9E3] border border-[#D4CBBF]"
            :class="{ 'border-bl-rounded': containerVsPods.length === index + 1 }"
          >
            <img
              v-if="item.pods"
              src="@/images/containers-vs-pods/true.png"
              alt="Yes"
            />
            <img
              v-else
              src="@/images/containers-vs-pods/false.png"
              alt="No"
            />
          </div>

          <div
            class="w-full flex justify-center items-center bg-white border border-[#D4CBBF]"
            :class="{ 'border-br-rounded': containerVsPods.length === index + 1 }"
          >
            <img
              v-if="item.containers"
              src="@/images/containers-vs-pods/true.png"
              alt="Yes"
            />
            <img
              v-else
              src="@/images/containers-vs-pods/false.png"
              alt="No"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
